import React from 'react'
import Subheader from '../../component/Subheader'
import RoomFeature from './RoomFeature'
import RoomLists from './RoomLists'

export default function RoomListing() {
  const subheadData = {
    heading: 'Rooms & Suites in De Coracao',
    breadcrumb: [
      {
        slug: "/resort-de-coracao-corbett",
        name: "Jim Corbett",
      },
      {
        slug: "",
        name: "Rooms",
      },
    ]
  }


  const roomList = [
    
    {
      category: "Luxury Room",
      title: "Luxury Room",
      description: "Enjoy a refreshing stay in these well-appointed rooms, offering modern comforts and large windows that frame the beautiful surrounding greenery.",
      image: "/image/corbettroom-luxury-room.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#home?propertyId=701Mn5Ca4GiFpRG7wK2385ZRnQ8BcTaRjrMkE4mjc5NQ==&JDRN=Y",
      detailLink: "/resort-de-coracao-corbett/luxury-room",
      specs: [
        "1 King Size Bed",
        "3 Guests Occupancy",
        "37 m² Room Area",
      ],
    },
    
    {
      category: "Luxury Cottages",
      title: "Luxury Cottages",
      description: "A perfect retreat for nature lovers and pet owners, these airy cottages offer easy garden access and a layout that welcomes the whole family.",
      image: "/image/corbettroom-luxury-cottages.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#home?propertyId=701Mn5Ca4GiFpRG7wK2385ZRnQ8BcTaRjrMkE4mjc5NQ==&JDRN=Y",
      detailLink: "/resort-de-coracao-corbett/luxury-cottages",
      specs: [
        "1 King Size Bed",
        "3 Guests Occupancy",
        "41 m² Room Area",
      ],
    },
        {
      category: "Premium Cottage",
      title: "Premium Cottages",
      description: "Recharge in these spacious independent stays, designed with a full-sized bathtub and warm wooden interiors for a classic forest-lodge feel.",
      image: "/image/corbettroom-premium.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#home?propertyId=701Mn5Ca4GiFpRG7wK2385ZRnQ8BcTaRjrMkE4mjc5NQ==&JDRN=Y",
      detailLink: "/resort-de-coracao-corbett/premium-cottages",
      specs: [
        "1 King Size Bed",
        "3 Guests Occupancy",
        "41 m² Room Area",
      ],
    },

    {
      category: "Club Cottages",
      title: "Club Cottages",
      description: "Experience the ultimate jungle indulgence in these private cottages, featuring a personal in-room Jacuzzi for a spa-like retreat amidst the wild.",
      image: "/image/corbettroom-club.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#home?propertyId=701Mn5Ca4GiFpRG7wK2385ZRnQ8BcTaRjrMkE4mjc5NQ==&JDRN=Y",
      detailLink: "/resort-de-coracao-corbett/club-cottages",
      specs: [
        "1 King Size Bed",
        "4 Guests Occupancy",
        "42 m² Room Area",
      ],
    },


    {
      category: "Family Cottages",
      title: "Family Cottages",
      description: "Our most expansive accommodation featuring two king beds, designed to provide plenty of space for families to relax and bond together.",
      image: "/image/corbettroom-family.webp",
      enquireLink: "/contact-us",
      bookLink: "https://www.swiftbook.io/inst/#home?propertyId=701Mn5Ca4GiFpRG7wK2385ZRnQ8BcTaRjrMkE4mjc5NQ==&JDRN=Y",
      detailLink: "/resort-de-coracao-corbett/family-cottages",
      specs: [
        "2 King Size Bed",
        "6 Guests Occupancy",
        "67 m² Room Area",
      ],
    },
  ];


const roomFeatureData = {
  features1: [
    {
      icon: "/image/room-feature-icon-1.webp",
      text: "Enjoy warm, personalized hospitality that makes your Jim Corbett accommodation comfortable, welcoming, and memorable.",
    },
    {
      icon: "/image/room-feature-icon-2.webp",
      text: "Relax in peaceful outdoor spaces while embracing the natural beauty and wilderness surrounding Jim Corbett.",
    },
    {
      icon: "/image/room-feature-icon-3.webp",
      text: "Savour thoughtfully prepared dishes featuring fresh ingredients, rich flavours, and memorable dining experiences.",
    },
  ],

  features2: [
    {
      icon: "/image/room-feature-icon-4.webp",
      text: "Find accommodation that offers a tranquil retreat where you can relax, recharge, and reconnect with nature.",
    },
    {
      icon: "/image/room-feature-icon-5.webp",
      text: "Natural materials, refined details, and thoughtfully designed interiors create a serene wilderness-inspired setting.",
    },
    {
      icon: "/image/room-feature-icon-6.webp",
      text: "Explore accommodation listings featuring comfortable rooms, quality amenities, and restful spaces after a day outdoors.",
    },
  ],
};


  return (
    <>
      <Subheader subheadData={subheadData} />
      <RoomLists roomList={roomList} />
      <RoomFeature data={roomFeatureData}/>
    </>
  )
}
